import request from '@/utils/request'

let Ma_training_recordApi = {

  /*岗前培训记录列表*/
  list(data) {
    return request._post('/shop/plus.ma_training_record.Index/index', data);
},
/*添加岗前培训记录*/
add(data) {
    return request._post('/shop/plus.ma_training_record.Index/add', data);
},
/*修改岗前培训记录*/
edit(data) {
    return request._post('/shop/plus.ma_training_record.Index/edit', data);
},
/*删除岗前培训记录*/
del(data) {
    return request._post('/shop/plus.ma_training_record.Index/del', data);
},
/*岗前培训记录详情*/
detail(data) {
  return request._post('/shop/plus.ma_training_record.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_training_record.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_training_record.Setting/getSetting', data, errorback);
    },
}
export default Ma_training_recordApi;



// WEBPACK FOOTER //
// ./src/api/ma_training_record.js